import type { SpotListSheetData } from '@/schemas/v2/spot'

/** ロック判定に必要なスポットの最小情報（GET /api/v2/spots の spots[].sheetIds） */
export type SpotForSheetLock = {
  sheetIds: number[]
}

/**
 * 購入連動ロック判定に必要なシートの最小情報。
 * 一覧レスポンスの SpotListSheetData と GET /api/v2/sheets の SheetData の共通部分。
 */
export type SheetLockInfo = {
  id: number
  locked: boolean
}

/** シートID → シート情報のマップを構築する（GET /api/v2/spots の sheets[] から生成） */
export function buildSheetById(sheets: SpotListSheetData[]): Map<number, SpotListSheetData> {
  const map = new Map<number, SpotListSheetData>()
  for (const sheet of sheets) map.set(sheet.id, sheet)
  return map
}

/**
 * スポットが購入連動ロック状態か判定する（#3414）。
 *
 * 「sheetIds が1件以上あり、その全てが locked」のときのみ true。
 * 1件でも非ロックのシートに属していればスタンプは獲得できる
 * （バックエンドの StampAvailabilityResolver::isLockedByAllSheets と同じ判定）。
 * sheetById に情報が無いシートIDは非ロック扱い（フェイルオープン）でサーバ判定に委ねる。
 */
export function isSpotPurchaseLocked(sheetIds: number[], sheetById: Map<number, SheetLockInfo>): boolean {
  if (sheetIds.length === 0) return false
  return sheetIds.every((id) => sheetById.get(id)?.locked === true)
}

/**
 * スポットが属する全シートがロック中か判定する（1つでも locked=false のシートがあれば false）。
 * 「近くのスポット」ダイアログ（DialogNearbySpots）の行を灰色表示にするために使う。
 * スポット一覧カードの灰色表示は #3414 で廃止済み。
 */
export function isSpotFullyLocked(spot: SpotForSheetLock, sheetById: Map<number, SheetLockInfo>): boolean {
  return isSpotPurchaseLocked(spot.sheetIds, sheetById)
}
